import styled from 'styled-components';

export const KycMessageContainer = styled.div`
    padding: 8px;
    display: grid;
    grid-template-columns: 17px 1fr;
    align-items: center;
    gap: 8px;
    border-radius: 5px;
    border:  1px solid #4F4F4F;
    font-size: 12px;
    color: #4F4F4F;
    background-color: #F6F6F6;
`



// WEBPACK FOOTER //
// ./src/components/funnel/payment-selection-step/kyc-message/KycMessageStyle.js